<template>
  <div style="width: 100%; height: 100%; position: absolute; top:0; left: 0; z-index: 2; pointer-events: none;" ref="canvas_f">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mouse: { x: undefined, y: undefined },
      frame: 0,
      circleArray: [],
      colorArray: ['255,102,0'],
      canvas: null,
      ctx: null,
    };
  },
  mounted() {
    let that = this;

    window.addEventListener('mousemove', that.handleMouseMove);
    window.addEventListener('touchmove', that.handleTouchMove);
    window.addEventListener('resize', that.handleResize);

    that.initCanvas();
    that.animate();

    window.onload= function (){
      window.addEventListener('mousemove', that.handleMouseMove);
      window.addEventListener('touchmove', that.handleTouchMove);
      window.addEventListener('resize', that.handleResize);

      that.initCanvas();
      that.animate();
    }
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('touchmove', this.handleTouchMove);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleMouseMove(event) {
      // 获取 canvas_f 容器的位置信息
      const rect = this.$refs.canvas_f.getBoundingClientRect();
      // 使用 clientX 和 clientY，并减去容器的左和上偏移量
      this.mouse.x = event.clientX - rect.left;
      this.mouse.y = event.clientY - rect.top;
      this.drawCircles();
    },
    handleTouchMove(event) {
      const touch = event.touches[0];
      const rect = this.$refs.canvas_f.getBoundingClientRect();
      this.mouse.x = touch.clientX - rect.left;
      this.mouse.y = touch.clientY - rect.top;
      this.drawCircles();
    },
    handleResize() {
      this.initCanvas();
    },
    initCanvas() {
      this.circleArray = [];
      this.canvas = this.$refs.canvas;
      // 使用 canvas_f 容器的尺寸
      this.canvas.height = this.$refs.canvas_f.offsetHeight;
      this.canvas.width = this.$refs.canvas_f.offsetWidth;
      this.ctx = this.canvas.getContext('2d');
    },
    // 工厂方法：创建一个 circle 对象
    createCircle(x, y, radius, vx, vy, rgb, opacity, birth, life, ctx) {
      let that = this;
      return {
        x: x,
        y: y,
        radius: radius,
        minRadius: radius,
        vx: vx,
        vy: vy,
        birth: birth,
        life: life,
        opacity: opacity,
        draw() {
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.radius, Math.PI * 2, false);
          ctx.fillStyle = `rgba(${rgb},${this.opacity})`;
          ctx.fill();
        },
        update(currentFrame) {
          // 使用 canvas_f 的尺寸来判断边界

          if (this.x + this.radius > that.$refs.canvas_f.offsetWidth || this.x - this.radius < 0) {
            this.vx = -this.vx;
          }
          if (this.y + this.radius > that.$refs.canvas_f.offsetHeight || this.y - this.radius < 0) {
            this.vy = -this.vy;
          }
          this.x += this.vx;
          this.y += this.vy;
          this.opacity = 1 - ((currentFrame - this.birth) / this.life);
          this.draw();
        }
      };
    },
    drawCircles() {
      for (let i = 0; i < 1; i++) {
        const radius = Math.floor(Math.random() * 2) + 1;
        const vx = Math.random() * 2 - 1;
        const vy = Math.random() * 2 - 1;
        const spawnFrame = this.frame;
        const rgb = this.colorArray[Math.floor(Math.random() * this.colorArray.length)];
        const life = 30;
        const circle = this.createCircle(this.mouse.x, this.mouse.y, radius, vx, vy, rgb, 1, spawnFrame, life, this.ctx);
        this.circleArray.push(circle);
      }
    },
    animate() {
      requestAnimationFrame(this.animate);
      this.frame++;
      if(this.$refs.canvas_f){
          this.ctx.clearRect(0, 0, this.$refs.canvas_f.offsetWidth, this.$refs.canvas_f.offsetHeight);
          // 更新所有粒子
          this.circleArray.forEach(circle => {
            circle.update(this.frame);
          });
      }
      // 移除过期粒子
      this.circleArray = this.circleArray.filter(circle => this.frame <= circle.birth + circle.life);
    }
  }
};
</script>

<style scoped>
body,
html {
  margin: 0;
  padding: 0;
  border: 0;
  font-family: 'Nunito', sans-serif;
}
body {
  background: #000;
}
canvas {
  margin: 0;
  padding: 0;
  display: block;
  touch-action: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ParticleSystem01.vue